import React from 'react';
import PropTypes from 'prop-types';

import './Overlay.scss';

const escapeKeycode = 27;
const lockBodyScrollingClass = 'body--locked';

/**
 * Overlay which sits on top of the current page
 */

class OverlayComponent extends React.Component {
  constructor(props) {
    super(props);

    this.closeOverlay = this.closeOverlay.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);

    // Display the overlay correctly if it is initially active
    const { isActive } = this.props;
    this.state = {
      isActive,
    };
    if (isActive) {
      this.lockBodyScroll();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const isCurrentActive = this.state.isActive;
    const isNextActive = nextProps.isActive;
    if (isNextActive && !isCurrentActive) {
      this.lockBodyScroll();
    }
    if (!isNextActive && isCurrentActive) {
      this.unlockBodyScroll();
    }

    this.setState({
      isActive: isNextActive,
    });
  }

  lockBodyScroll() {
    window.addEventListener('keyup', this.onKeyPress);
    this.props.actions.toggleDOMClass({ selector: 'body', className: lockBodyScrollingClass, type: 'add' });
  }

  unlockBodyScroll() {
    window.removeEventListener('keyup', this.onKeyPress);
    this.props.actions.toggleDOMClass({ selector: 'body', className: lockBodyScrollingClass, type: 'remove' });
  }

  onKeyPress(event) {
    if (event.keyCode === escapeKeycode) {
      this.closeOverlay();
    }
  }

  closeOverlay() {
    this.unlockBodyScroll();
    this.setState({
      isActive: false,
    });
    this.props.actions.closeOverlay();
  }

  render() {
    const activeClass = this.state.isActive ? 'overlay-component--active' : '';
    return (
      <div className={`overlay-component ${activeClass}`}>
        <div className="overlay-container">{this.props.children}</div>
      </div>
    );
  }
}

OverlayComponent.propTypes = {
  overlayName: PropTypes.string,
  isActive: PropTypes.bool,
  actions: PropTypes.shape({
    toggleDOMClass: PropTypes.func.isRequired,
    closeOverlay: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node,
};

OverlayComponent.defaultProps = {
  overlayName: '',
};

OverlayComponent.displayName = 'Overlay';

export default OverlayComponent;
